import { api } from './client.js';

export const myAuditLog = (limit = 100) => api.get(`/audit-log/me?limit=${limit}`);
